import PropTypes from "prop-types";
import React, { useState, useEffect, useRef, Fragment } from "react";
import { connect, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { getDiscountPrice } from "../../helpers/product";
import ProductImageGallery from "../../components/product/ProductImageGallery";
import ProductDescriptionInfo from "../../components/product/ProductDescriptionInfo";
import ProductImageGallerySideThumb from "../../components/product/ProductImageGallerySideThumb";
import { isEmpty } from "lodash";
import Swiper from "react-id-swiper";
import { Carousel, Col, Row, Spin, Modal } from "antd";
import {
  extractYouTubeVideoId,
  getImagesForAllVariants,
  getImagesForImageDisplay,
  getPriceRelatedToCustomer,
  youtubeLinkIdParser,
} from "../../pages/constant/utils";
import {
  emptyDetailProduct,
  fetchProductBySlugOnPageReload,
  setLoadingState,
} from "../../redux/actions/productActions";
import { useHistory } from "react-router-dom";
import {
  ProductVariantDisplayType,
  defaultImageUrl,
  defaultLogo,
} from "../../pages/constant/Constants";
import Upcoming from "./../../assets/images/Upcoming.png";
import { MetaTags } from "react-meta-tags";
import Promotions from "../../components/common/Promotions";
import { PlayCircleOutlined } from "@ant-design/icons";

const ProductImageDescription = ({
  spaceTopClass,
  spaceBottomClass,
  product,
  currency,
  cartItems,
  wishlistItems,
  compareItems,
  userData,
  loadingState,
  settingData,
  themeSettingData,
}) => {
  const elementRef = useRef(null);
  const [gallerySwiper] = useState(null);
  const [thumbnailSwiper] = useState(null);
  const [elementHeight, setElementHeight] = useState("fit-content");
  const [scroll, setScroll] = useState();
  const [combineSelectedImage, setCombineSelectedImage] = useState("");
  const [affixEnabled, setAffixEnabled] = useState(true);
  const [selectedImage, setSelectedImage] = useState(combineSelectedImage);
  const [selectedVariant, setSelectedVariant] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);

  useEffect(() => {
    // if(!product) {
    dispatch(setLoadingState(true));
    dispatch(
      fetchProductBySlugOnPageReload(
        history?.location?.pathname?.split("/")[2],
        () => {
          history.push(`/shop`);
        }
      )
    );
    // }
    return () => {
      dispatch(emptyDetailProduct({}));
    };
  }, []);

  let [displayTypeImages, setDisplayTypeImages] = useState([]);

  useEffect(() => {
    if (displayTypeImages?.length > 0) {
      setSelectedImage(displayTypeImages[0]);
    }
  }, [displayTypeImages]);

  // Set selected key
  useEffect(() => {
    if (combineSelectedImage) {
      setSelectedKey(
        displayTypeImages.findIndex((img) => img === combineSelectedImage)
      );
    }
  }, [combineSelectedImage]);

  useEffect(() => {
    setSelectedKey(0);
    setSelectedImage("");
    let images = getImagesForShowingInTheDetailPage()[0]
    if (images?.video) {
      setSelectedImage({ video: images.video });
    }
  }, [selectedVariant]);

  const wishlistItem = wishlistItems.filter(
    (wishlistItem) => wishlistItem.id === product.id
  )[0];

  const compareItem = compareItems.filter(
    (compareItem) => compareItem.id === product.id
  )[0];

  const { addToast } = useToasts();

  const discountedPrice = getDiscountPrice(product.price, product.discount);
  const finalProductPrice = +(
    getPriceRelatedToCustomer(userData, product) * currency.currencyRate
  ).toFixed(2);
  const finalDiscountedPrice = +(
    discountedPrice * currency.currencyRate
  ).toFixed(2);

  const [selectedKey, setSelectedKey] = useState(0);

  useEffect(() => {
    const height = elementRef.current?.offsetHeight;
    setElementHeight(`${height - 20}px`);
  }, []);

  const [isListVariant, setIsListVariant] = useState(false);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!isEmpty(product)) {
      let temp = product.variant_attributes?.find(
        ({ display_type }) =>
          display_type == ProductVariantDisplayType.DETAILED_LIST.type
      );
      if (temp) {
        setIsListVariant(true);
        const tempObj = [...product.variant_product, product].find(
          (proEle) => proEle.default_variant == true
        );
        if (!isEmpty(tempObj)) {
          setDescription(tempObj?.description || "");
        }
      }
    }
  }, [product]);

  const ProductDescriptionTemplate = ({ description }) => {
    if (!description) {
      return null;
    }

    return (
      <div className="div-16" style={{ marginBottom: "100px", padding:"10px" }}>
        <div className="detail-discription">Description</div>
        <hr style={{ margin: "30px 0", border: "1px solid #ccc" }} />

        <div
          className="detail-discription-text"
          style={{ fontSize: '22px' }}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
    );
  };

  const checkIsImageDefault = (image) => {
    return image == defaultImageUrl;
  };
  const getImagesForShowingInTheDetailPage = () => {
    let tempImages = [];
    if (product?.variant_product?.length) {
      let findedProduct = [
        { ...product, variant_product: null },
        ...product.variant_product,
      ].find((product) => product.name == selectedVariant?.name);
      if (findedProduct?.images?.length) {
        findedProduct.images.forEach((image) => {
          if (!checkIsImageDefault(image)) {
            tempImages.push(image);
          }
        });
        if (findedProduct?.video) {
          tempImages.push({ video: findedProduct.video });
        }
      } else {
        if (findedProduct?.video) {
          tempImages.push({ video: findedProduct.video });
        }
      }
    } else {
      if (product?.images?.length) {
        product.images.forEach((image) => {
          if (!checkIsImageDefault(image)) {
            tempImages.push(image);
          }
        });
      }
      if (product?.video) {
        tempImages.push({ video: product.video });
      }
    }

    if (!tempImages.length) {
      tempImages.push(themeSettingData?.logo || Upcoming)
    }

    return tempImages;
  };
  const handleMouseMove = (event) => {
    const container = event.currentTarget;
    const rect = container.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / container.offsetWidth) * 100;
    const y = ((event.clientY - rect.top) / container.offsetHeight) * 100;
    container.style.setProperty('--mouse-x', `${x}%`);
    container.style.setProperty('--mouse-y', `${y}%`);
  };
  const selectedImageUrl = selectedImage?.url || selectedImage || getImagesForShowingInTheDetailPage()[0];
  const altText = selectedImage?.alt_text
  ? selectedImage?.alt_text
  : product?.ecom_name || product?.name

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <Fragment>
      <MetaTags>
        <title>
          {product?.product_seo_meta_data?.title
            ? product?.product_seo_meta_data?.title
            : product?.ecom_name
              ? product?.ecom_name
              : settingData?.account_title}
        </title>
        <meta
          name="description"
          content={
            product?.product_seo_meta_data?.description
              ? product?.product_seo_meta_data?.description
              : product?.description
          }
        />
      </MetaTags>
      <div style={{ minHeight: "500px" }}>
        <Spin spinning={loadingState} style={{ marginTop: "250px" }}>
          {!isEmpty(product) && (
            <div
              className="pro-top-padding"
            >
              <div className="pro-padding">
                <Row>
                  <Col
                    xxl={10}
                    xl={11}
                    lg={12}
                    md={24}
                    sm={24}
                    xs={24}
                    className="image-side-column"
                  >
                    <div className="side-product-images">
                      {(() => {
                        let images = getImagesForShowingInTheDetailPage();
                        return images?.map((image, key) => {
                          if (!image?.video) {
                            return (
                              <div
                                className={`thumbnail ${selectedKey == key ? "selected-thumbnail" : ""
                                  }`}
                                onClick={() => {
                                  setSelectedKey(key);
                                  setSelectedImage(image);
                                  setCombineSelectedImage("");
                                }}
                              >
                                <img
                                  src={image}
                                  alt={
                                    image?.alt_text
                                      ? image?.alt_text
                                      : product?.ecom_name || product?.name
                                  }
                                />
                              </div>
                            );
                          } else {
                            return (
                              <div
                                style={{
                                  width: "82px",
                                  height: "89px",
                                  marginTop: "5px",
                                }}
                                className={`thumbnail ${selectedKey == key ? "selected-thumbnail" : ""
                                  }`}
                                onClick={() => {
                                  setSelectedKey(key);
                                  setSelectedImage(image);
                                  setCombineSelectedImage("");
                                }}
                              >
                                {/* Wrapping div around the iframe to block interaction */}
                                <div
                                  style={{
                                    background: `url(https://img.youtube.com/vi/${extractYouTubeVideoId(image.video)}/maxresdefault.jpg)`,
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "cover",
                                    width: "75px",
                                    height: "75px",
                                    marginTop: "5px",
                                    marginLeft: "2px",
                                    paddingTop: "2px",
                                    paddingLeft: "2px"
                                  }}
                                >
                                  <svg width="30" style={{
                                    margin: "20px",
                                  }} height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22.9592 6.48337C22.8276 5.99729 22.5711 5.55415 22.215 5.19809C21.8589 4.84203 21.4157 4.58549 20.9297 4.454C19.1501 3.96875 11.9885 3.96875 11.9885 3.96875C11.9885 3.96875 4.82668 3.98348 3.04738 4.46873C2.56131 4.60023 2.11818 4.85679 1.76213 5.21285C1.40607 5.5689 1.14951 6.01203 1.01801 6.4981C0.479743 9.65995 0.270916 14.4776 1.03274 17.5128C1.16424 17.9988 1.4208 18.442 1.77685 18.798C2.13291 19.1541 2.57604 19.4106 3.0621 19.5421C4.84155 20.0274 12.0032 20.0274 12.0032 20.0274C12.0032 20.0274 19.1649 20.0274 20.9444 19.5421C21.4304 19.4106 21.8736 19.1541 22.2296 18.798C22.5857 18.442 22.8422 17.9988 22.9737 17.5128C23.5413 14.3466 23.7164 9.53191 22.959 6.48351" fill="#FF0000" />
                                    <path d="M9.70898 15.437L15.6501 11.9959L9.70898 8.55469V15.437Z" fill="white" />
                                  </svg>

                                </div>
                              </div>
                            );
                          }
                        });
                      })()}
                    </div>
                    {/* <pre>{JSON.stringify(selectedImage, null, 2)}</pre> */}
                    <div
                      className={` ${(combineSelectedImage ||
                        selectedImage?.url ||
                        selectedImage) === defaultImageUrl
                        ? "default-logo-discription display"
                        : "display"
                        }`}
                    >
                      {selectedImage?.video ? (
                        <>
                          <iframe
                            className="embed-responsive-item"
                            width={"100%"}
                            src={`https://www.youtube.com/embed/${youtubeLinkIdParser(selectedImage?.video)}?autoplay=1&loop=1`}
                            allow="autoplay; fullscreen"
                            allowfullscreen="allowfullscreen"
                            mozallowfullscreen="mozallowfullscreen"
                            msallowfullscreen="msallowfullscreen"
                            oallowfullscreen="oallowfullscreen"
                            webkitallowfullscreen="webkitallowfullscreen"
                          ></iframe>

                        </>
                      ) : (
                        <>
                          <div style={{ position: 'relative', maxWidth: '100%' }}>
                              <div
                                className="image-zoom-container"
                                onMouseMove={handleMouseMove}
                                onClick={openModal}
                                style={{ cursor: 'pointer' }}
                              >
                                <img
                                  id="largeImage"
                                  src={ selectedImageUrl }
                                  alt={
                                    selectedImage?.alt_text
                                      ? selectedImage?.alt_text
                                      : product?.ecom_name || product?.name
                                  }
                                  style={{
                                    display: 'block',
                                    backgroundColor: '#f7f7f7',
                                  }}
                                />
                              </div>
                              <Modal
                                visible={isModalOpen}
                                onCancel={closeModal}
                                footer={null}
                                centered
                                className="image-zoom-container-modal"
                              >
                                <img
                                  src={ selectedImageUrl }
                                  alt={
                                    altText
                                  }
                                  style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                  }}
                                />
                              </Modal>
                            {selectedVariant?.selected_unit_price?.promotion?.has_sale_badge && 
                            <div className="promotion-detail-page">
                              <Promotions
                                product={selectedVariant}
                                classMain={"promotion-detail"} 
                                classText={"promotion-text-detail"}
                              />
                            </div>
                          }
                          </div>
                        </>
                      )}
                    </div>
                  </Col>
                  <Col
                    ref={elementRef}
                    xxl={14}
                    xl={13}
                    lg={12}
                    md={24}
                    sm={24}
                    xs={24}
                    // className="col-lg-6 col-md-6 pro-des"
                  >
                    {/* product description info */}
                    <ProductDescriptionInfo
                      combineSelectedImage={combineSelectedImage}
                      selectedVariant={selectedVariant}
                      setSelectedVariant={setSelectedVariant}
                      setCombineSelectedImage={setCombineSelectedImage}
                      discountedPrice={discountedPrice}
                      currency={currency}
                      finalDiscountedPrice={finalDiscountedPrice}
                      finalProductPrice={finalProductPrice}
                      cartItems={cartItems}
                      wishlistItem={wishlistItem}
                      compareItem={compareItem}
                      addToast={addToast}
                    />
                  </Col>
                </Row>

                {/* {((!isListVariant && selectedVariant?.description) || (isListVariant && !selectedVariant?.description && description) || (!isListVariant && !selectedVariant?.description && product?.description)) && ( */}
                <ProductDescriptionTemplate
                  description={
                    !isListVariant && selectedVariant?.description
                      ? selectedVariant?.description
                      : isListVariant && description
                        ? description
                        : selectedVariant?.variant_product?.length == 0 &&
                          selectedVariant?.description
                          ? selectedVariant?.description
                          : null
                  }
                />
                {/* // )} */}
              </div>
            </div>
          )}
        </Spin>
      </div>
    </Fragment>
  );
};

ProductImageDescription.propTypes = {
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  currency: PropTypes.object,
  settingData: PropTypes.object,
  galleryType: PropTypes.string,
  loadingState: PropTypes.bool,
  product: PropTypes.object,
  userData: PropTypes.object,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  wishlistItems: PropTypes.array,
};

const mapStateToProps = (state) => {
  return {
    currency: state.settingData?.["admin-panel"]?.basic || {},
    settingData: state.settingData.ecom.basic,
    themeSettingData: state.settingData.ecom.theme,
    cartItems: state.cartData,
    wishlistItems: state.wishlistData,
    compareItems: state.compareData,
    userData: state.userData.user,
    loadingState: state.productData.loading,
    product: state.productData.detailProduct,
  };
};

export default connect(mapStateToProps)(ProductImageDescription);
